import { jsx as l } from "react/jsx-runtime";
const M = (Z) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...Z,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M40.5 17.28C37.82 15.73 34.9 15 32.02 15c-5.88 0-11.59 3.05-14.74 8.5-4.69 8.13-1.91 18.53 6.22 23.22 2.68 1.55 5.6 2.28 8.48 2.28 5.88 0 11.59-3.05 14.74-8.5 4.7-8.13 1.91-18.53-6.22-23.22Zm2.76 21.22a12.942 12.942 0 0 1-4.85 4.81c-1.96 1.1-4.18 1.69-6.42 1.69s-4.51-.6-6.48-1.75a12.928 12.928 0 0 1-6.06-7.89c-.9-3.35-.44-6.86 1.3-9.86 1.16-2.01 2.84-3.68 4.85-4.81 1.96-1.11 4.18-1.69 6.42-1.69s4.51.6 6.48 1.74c3.01 1.74 5.16 4.54 6.06 7.89.9 3.35.44 6.86-1.3 9.87ZM44.132 8.983l-2.76 4.78 1.732 1 2.76-4.78-1.732-1ZM9.981 18.137l-1 1.732 4.78 2.76 1-1.732-4.78-2.76ZM20.895 49.238l-2.76 4.78 1.732 1 2.76-4.78-1.732-1ZM50.236 41.374l-1 1.732 4.78 2.76 1-1.732-4.78-2.76ZM56.727 23.827l-5.332 1.428.777 2.898 5.331-1.428-.776-2.898ZM26.714 6.497l-2.898.777 1.428 5.332 2.898-.777-1.428-5.332ZM11.825 35.847l-5.331 1.428.776 2.898 5.332-1.429-.777-2.897ZM38.753 51.394l-2.898.776 1.429 5.332 2.897-.776-1.428-5.332Z"
      }
    )
  }
);
export {
  M as Sun
};
